import React from 'react';

function Blog() {
    return (
        <div className="container text-center">
            <h1>Blog</h1>
        </div>
    )
}

export default Blog;
